import { useTranslation } from 'react-i18next';
import { groupTeamsByCountry, getCountryLabel } from '../utils';

const TeamInstallerSection = ({ formData, setFormData, teams, installers }) => {
  const { t } = useTranslation();
  const groupedTeams = groupTeamsByCountry(teams);

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{t('appointment.team')} *</label>
        <select
          value={formData.team_id}
          onChange={(e) => setFormData({ ...formData, team_id: e.target.value, assigned_installer_id: "" })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lojack-red"
          required
          data-testid="appointment-team"
        >
          <option value="">{t('appointment.selectTeam')}</option>
          {Object.entries(groupedTeams).map(([country, countryTeams]) => (
            <optgroup key={country} label={getCountryLabel(country)}>
              {countryTeams.map((team) => (
                <option key={team.id} value={team.id}>{team.name}</option>
              ))}
            </optgroup>
          ))}
        </select>
      </div>
      <div>
        <label className="block text-sm font-medium text-gray-700 mb-2">{t('appointment.assignedInstaller')} *</label>
        <select
          value={formData.assigned_installer_id}
          onChange={(e) => setFormData({ ...formData, assigned_installer_id: e.target.value })}
          className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-lojack-red"
          disabled={!formData.team_id || installers.length === 0}
          required
          data-testid="appointment-installer"
        >
          <option value="">{t('appointment.selectInstaller')}</option>
          {installers.map((installer) => (
            <option key={installer.id} value={installer.id}>
              {installer.first_name} {installer.last_name}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default TeamInstallerSection;
